import { Component, OnInit, ViewChild, EventEmitter, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { MaterializeDirective, MaterializeAction } from 'angular2-materialize';
import * as Materialize from 'angular2-materialize/dist/index';
import { customerService } from './customers.service';
import { SharedService } from '../shared/shared.service';
import { CommonService } from '../navbar/searchCommon.service';
import { NavbarService } from '../navbar/navbar.service';
import { CreateCustomerComponent } from '../createcustomer/createcustomer.component';


@Component({
  selector: 'app-customers',
  templateUrl: './customers.component.html',
  styleUrls: ['./customers.component.css'],
  providers: [customerService]
})
export class CustomersComponent implements OnInit, OnDestroy {

  planid: string;
  email: string;
  accounts = [];
  account: any;
  loadingcustomers: boolean;

  contactnameDict = [];
  contactphoneDict = [];
  contactEmailDict = [];
  contactArray = [];
  editedContactArray = [];
  editedOwnerArray = [];
  editedStatusArray = [];
  ownerDict = [];
  ownerEmailDict = [];
  ownerArray = [];
  statusDict = [];
  statusArray = [];

  companyname: string;
  addressone: string;
  addresstwo: string;
  companycity: string;
  companystate: string;
  companyzip: string;
  companycountry: string;
  companyphone: string;
  companyfax: string;
  companyurl: string;
  primarycontactfirstname: string;
  primarycontactlastname: string;
  primarycontactemail: string;
  primarycontactphone: string;
  accountowner: string;
  requiredfieldEmpty: boolean = true;
  requiredContactfieldEmpty: boolean = true;
  newContactfirstname: string;
  newContactlastname: string;
  newContactemail: string;
  newContactphone: string;
  newContacttitle: string;

  customerExists: boolean = false;

  primarycontactselect: number;
  ownerselect: number;
  statusselect: number;
  errorMessage: string;
  selectedassignee: string;
  selectedAccount: any = [];
  RelatedContactsArray: any = [];
  selectedPrimaryContact: any = [];
  contacts: any = [];

  selectedOwnerArray: any = [];
  selectedAccountsOwner: any = [];
  public filteredOwnerList = [];
  public gotAccountContacts = false;
  isRemovable = true;
  isEnabled = false;
  projectChecking = false;
  accountname = '';
  public comments = 'Comments are as follows';
  waiticon = '';
  updatedUserState = false;
  primarycontactchanged = false;
  EditedPrimaryContactPhone = '';
  changedprimarycontactphone = '';
  dropdownActive = false;
  modalNewAccountAction = new EventEmitter<string | MaterializeAction>();
  modalAccountInfoAction = new EventEmitter<string | MaterializeAction>();
  modalNewAccountContactAction = new EventEmitter<string | MaterializeAction>();
  modalRemoveAccountAction = new EventEmitter<string | MaterializeAction>();
  modalRemoveAccountContactAction = new EventEmitter<string | MaterializeAction>();
  // Pagination
  public filter: string = '';
  public filter1: string = '';
  public maxSize: number = 7;
  public directionLinks: boolean = true;
  public autoHide: boolean = false;
  public config = {
    itemsPerPage: 20,
    currentPage: 1,
    totalItems: 1
  };

  filledstar: number;
  halfstar: number;
  emptystar: number;
  accountRatingSelect: number;
  public dateFormat: string;

  constructor(private router: Router,
              private customerservice: customerService,
              private commonService: CommonService,
              private service: SharedService,
              public navService: NavbarService) { }

    ngOnInit() {
      this.navService.show('CUSTOMERS');
      this.navService.setNavID(2);
      this.planid = localStorage.getItem('mr_planid');
      this.dateFormat = localStorage.getItem('mr_date_format_id');
      // refactor
      // TODO we should / could refactor the user as a whole to a service which contains strict letiables about the user
      //  how this leties compared to using multiple localStorage.get(s) I am unsure but will research.
      this.email = localStorage.getItem('mr_email');

      this.loadingcustomers = true;
      this.selectedassignee = this.email;
      this.customerExists = true;
      this.refreshCustomers();
    }

    ngAfterViewInit() {
    }

    ngOnDestroy() {
      this.modalNewAccountAction.emit({ action: 'modal', params: ['close'] });
      this.modalAccountInfoAction.emit({ action: 'modal', params: ['close'] });
      this.modalNewAccountContactAction.emit({ action: 'modal', params: ['close'] });
      this.modalRemoveAccountAction.emit({ action: 'modal', params: ['close'] });
      this.modalRemoveAccountContactAction.emit({ action: 'modal', params: ['close'] });
    }

    refreshCustomers() {
      this.customerservice.getCustomersPage(this.config.currentPage, this.config.itemsPerPage)
      .subscribe(
        data => {
          console.log('Got customers');
          console.log('customerExists', this.customerExists);
          let accountdata = JSON.parse(data);
          // this.tempusers = userdata.users;
          console.log(accountdata);
          this.accounts = accountdata.customers;
          this.loadingcustomers = false;
          this.customerExists = true;

          this.config.currentPage = Number(accountdata.pagenum);
          this.config.totalItems = accountdata.count;

          // temporary hardcoded values
          this.ownerArray = accountdata.owners;
          this.contactArray = accountdata.contacts;
          this.statusArray = JSON.parse('[{"id":0,"name":"Inactive","enable":0},{"id":1,"name":"Active","enable":1}]');
          this.editedContactArray = [];
          this.editedOwnerArray = [];
          this.editedStatusArray = [];

          for (let i = 0; i < this.ownerArray.length; i++) {
            this.ownerDict[this.ownerArray[i].id] = this.ownerArray[i].firstname + ' ' + this.ownerArray[i].lastname;
            this.ownerEmailDict[this.ownerArray[i].id] = this.ownerArray[i].email;
          }

          for (let i = 0; i < this.contactArray.length; i++) {
            this.contactnameDict[this.contactArray[i].id] = this.contactArray[i].firstname + ' ' + this.contactArray[i].lastname;
            this.contactEmailDict[this.contactArray[i].id] = this.contactArray[i].email;
            this.contactphoneDict[this.contactArray[i].id] = this.contactArray[i].phone;
          }

          for (let i = 0; i < this.statusArray.length; i++) {
            this.statusDict[this.statusArray[i].id] = this.statusArray[i].name;
          }

          for (let i = 0; i < this.accounts.length; i++) {
            let accountrating = this.accounts[i].rating;
            this.calculateStarRating(i, accountrating);
          }

        },
        error => {
          this.loadingcustomers = false;
        });
      }

      filterAssignee() {
        if (this.selectedassignee) {
          this.filteredOwnerList = this.ownerArray.filter(function (el) {
            if (el.email) {
              return el.email.toLowerCase().indexOf(this.selectedassignee.toLowerCase()) > -1;
            } else {
              for (let i = 0; i < this.ownerArray.length; i++) {
                this.filteredOwnerList[i] = this.ownerArray[i].name;
              }
              return this.filteredOwnerList;
            }
          }.bind(this));
        } else {
          this.filteredOwnerList = [];
        }
      }

      selectOwner(owner) {
        this.selectedassignee = owner.email;
        this.filteredOwnerList = [];
      }

      getKeyByValue(dictionary, value) {
        for (let i in dictionary) {
          if (dictionary.hasOwnProperty(i)) {
            if (dictionary[i] === value) {
              return i;
            }
          }
        }
      }

      getValueByID(Array, Id) {
        for (let i in Array) {
          if (Array.hasOwnProperty(i)) {
            if (Array[i].id === Id) {
              return Array[i];
            }
          }
        }
      }

      openModalAccountInfo() {
        this.addIndicatorStyle();
        this.modalAccountInfoAction.emit({ action: 'modal', params: ['open'] });
        this.selectedPrimaryContact = [];
        this.dropdownActive = false;
        this.refreshCustomersInfo(this.selectedAccount.id);
      }

      refreshCustomersInfo(accountID) {
        this.customerservice.getCustomerInfo(accountID).subscribe(
          data => {
            console.log('Account info : ', data);
            let accountdata = JSON.parse(data);
            this.selectedAccount = accountdata.customer[0];
            this.calculateStarRatingForSelectedAccount(this.selectedAccount.rating);
            if (accountdata.related_contacts.length > 0) {
              this.RelatedContactsArray = accountdata.related_contacts;
              this.selectedPrimaryContact = this.getValueByID(this.RelatedContactsArray, this.selectedAccount.primary_contact_id);
              this.contacts = accountdata.related_contacts;
              this.setPrimaryContact(this.selectedAccount, this.contacts);
              this.gotAccountContacts = true;
            } else {
              this.gotAccountContacts = false;
            }
          },
          error => {

          });
        }

        setPrimaryContact(account, contacts) {
          for (let i in contacts) {
            if (contacts.hasOwnProperty(i)) {
              if (contacts[i].id === account.primary_contact_id) {
                contacts[i].isprimary = true;
              } else {
                contacts[i].isprimary = false;
              }
            }
          }
        }

        openmodalNewAccountContact() {
          this.modalNewAccountContactAction.emit({ action: 'modal', params: ['open'] });
        }

        openModalRemoveAccount() {
          this.dropdownActive = false;
          this.storeCustomerInfo(this.selectedAccount);
          this.modalRemoveAccountAction.emit({ action: 'modal', params: ['open'] });
        }


        confirmCustomerContactDelete() {
        }


        confirmDeactivate() {
          this.waiticon = 'fa right fa-spinner fa-pulse';
          (<HTMLInputElement>document.getElementById('deactivateCustomerBtn')).disabled = true;
          // (<HTMLInputElement>document.getElementById('cancelUserDeleteBtn')).disabled = true;

          this.customerservice.changeCustomerStatus(this.selectedAccount.id, 0).subscribe(
            data => {
              console.log(' change state Done. ');
              this.waiticon = '';
              (<HTMLInputElement>document.getElementById('deactivateCustomerBtn')).disabled = false;
              this.modalRemoveAccountAction.emit({ action: 'modal', params: ['close'] });
              Materialize.toast('CUSTOMER DEACIVATED SUCCESSFULLY', 2000);

              // window.location.reload();
              this.refreshCustomers();
            },
            error => {
              console.log('result: ' + error);
              Materialize.toast('result: ' + error, 5000);
              this.waiticon = '';
              (<HTMLInputElement>document.getElementById('deactivateCustomerBtn')).disabled = false;
            });
          }

          confirmCustomerDelete() {
            console.log('Customer id:', this.selectedAccount.id);
            this.waiticon = 'fa right fa-spinner fa-pulse';
            (<HTMLInputElement>document.getElementById('customerDeleteBtn')).disabled = true;

            this.customerservice.deleteCustomer(this.selectedAccount.id).subscribe(
              data => {
                Materialize.toast('CUSTOMER ' + this.selectedAccount.name + ' HAS BEEN DELETED', 2000);
                this.waiticon = '';
                this.modalRemoveAccountAction.emit({ action: 'modal', params: ['close'] });
                this.refreshCustomers();
              },
              error => {
                console.log('Error deleting customer:' + error);
                Materialize.toast('ERROR DELETING CUSTOMER - PLEASE TRY AGAIN', 2000);
                this.waiticon = '';
                this.modalRemoveAccountAction.emit({ action: 'modal', params: ['close'] });
                (<HTMLInputElement>document.getElementById('customerDeleteBtn')).disabled = false;
                this.errorMessage = <any>error;
                console.error('confirmCustomerDelete() error:', this.errorMessage);
              });
            }

            openOptions(id, account) {
              if (!this.dropdownActive) {
                this.selectedAccount = account;
                this.dropdownActive = true;
              } else {
                this.dropdownActive = false;
              }
            }

            storeCustomerInfo(account) {
              this.projectChecking = true;
              this.customerservice.getCustomerProjects(account.id).subscribe(
                data => {
                  console.log(' get customers project info : ', data);
                  let accProject = JSON.parse(data);
                  if (accProject.projectcount > 0) {
                    this.isRemovable = false;
                  } else {
                    this.isRemovable = true;
                  }
                  this.selectedAccount = account;

                  if (account.enabled) {
                    this.isEnabled = true;
                  } else {
                    this.isEnabled = false;
                  }
                  this.projectChecking = false;
                  this.accountname = account.name;
                },
                error => {
                  this.errorMessage = <any>error;
                  this.projectChecking = false;
                  console.error('confirmUserDelete() error:', this.errorMessage);
                }
              );
            }

            openModalRemoveAccountContact() {
              this.dropdownActive = false;
              this.modalRemoveAccountContactAction.emit({ action: 'modal', params: ['open'] });
            }

            checkEmptyField() {
              if (this.companyname && this.primarycontactfirstname && this.primarycontactlastname) {
                this.requiredfieldEmpty = false;
              } else {
                this.requiredfieldEmpty = true;
              }
            }

              onPrimaryContactnameChange(value) {
                console.log('onPrimaryContactnameChange value', value);
                this.primarycontactchanged = true;
                this.primarycontactselect = value;
              }

              onOwnerChange(value) {
                console.log('owner value', value);
                this.ownerselect = value;
              }

              onStatusChange(value) {
                console.log('Status value', value);
                this.statusselect = value;
              }

              onAccountRatingChange(value) {
                console.log('Status value', value);
                this.accountRatingSelect = value;
              }

              editCustomer(customerdetails: any) {
                this.customerservice.updateCustomer(customerdetails)
                .subscribe(
                  data => {
                    console.log('customer data : ', data);
                    this.refreshCustomers();
                  },
                  error => {

                  });
                }

                changeActivityState() {
                  console.log('current status : ', this.selectedAccount.enabled);
                  if (this.selectedAccount.enabled) {
                    this.selectedAccount.enabled = 0;
                  } else {
                    this.selectedAccount.enabled = 1;
                  }
                  let updatecustomerdetails = {
                    id: this.selectedAccount.id,
                    enabled: this.selectedAccount.enabled,
                  };

                  // Create the project to be able to get the project ID
                  this.customerservice.updateCustomer(updatecustomerdetails)
                  .subscribe(
                    data => {
                      this.refreshCustomers();
                    },
                    error => {
                      this.errorMessage = <any>error;
                      console.error('getProjects() error:', this.errorMessage);
                    });
                  }

                  editCustomerRow(index) {
                    document.getElementById('name' + index).style.display = 'none';
                    document.getElementById('nameEdit' + index).style.display = 'block';

                    document.getElementById('contactmail' + index).style.display = 'none';
                    document.getElementById('contactmailEdit' + index).style.display = 'block';

                    document.getElementById('contactphone' + index).style.display = 'none';
                    document.getElementById('contactphoneEdit' + index).style.display = 'block';

                    document.getElementById('owner' + index).style.display = 'none';
                    document.getElementById('ownerEdit' + index).style.display = 'block';

                    document.getElementById('status' + index).style.display = 'none';
                    document.getElementById('statusEdit' + index).style.display = 'block';

                    document.getElementById('accountrating' + index).style.display = 'none';
                    document.getElementById('accountratingEdit' + index).style.display = 'block';

                    document.getElementById('default_margin' + index).style.display = 'none';
                    document.getElementById('default_marginEdit' + index).style.display = 'block';


                    document.getElementById('customerEdit' + index).style.display = 'none';
                    document.getElementById('customerSave' + index).style.display = 'block';
                    document.getElementById('customerCancel' + index).style.display = 'block';
                    document.getElementById('ddcustButtton' + index).style.display = 'none';

                    this.primarycontactchanged = false;
                    this.EditedPrimaryContactPhone = (<HTMLInputElement>document.getElementById('contactphoneEdit' + index)).value;
                    this.primarycontactselect = this.accounts[index].primary_contact_id;
                    this.ownerselect = this.accounts[index].owner_id;
                    this.statusselect = this.accounts[index].enabled;
                    this.accountRatingSelect = this.accounts[index].rating;
                    this.editedContactArray = this.accounts[index].contacts;
                    this.editedOwnerArray = this.ownerArray;
                    this.editedStatusArray = this.statusArray;
                  }

                  saveRow(index) {
                    document.getElementById('name' + index).style.display = 'block';
                    document.getElementById('nameEdit' + index).style.display = 'none';
                    this.accounts[index].name = (<HTMLInputElement>document.getElementById('nameEdit' + index)).value;

                    document.getElementById('contactmail' + index).style.display = 'block';
                    document.getElementById('contactmailEdit' + index).style.display = 'none';
                    this.accounts[index].primary_contact_id = Number(this.primarycontactselect);

                    document.getElementById('contactphone' + index).style.display = 'block';
                    document.getElementById('contactphoneEdit' + index).style.display = 'none';

                    let rating = Number((<HTMLInputElement>document.getElementById('accountratingSelectEdit' + index)).value);
                    this.accounts[index].rating = rating;

                    let primarycontact, primarycontactphone;
                    let changedprimarycontactphone;
                    for (let i in this.contactArray) {
                      if (this.contactArray.hasOwnProperty(i)) {
                        if (this.contactArray[i].id === this.accounts[index].primary_contact_id) {
                          primarycontact = this.contactArray[i];
                          primarycontactphone = this.contactArray[i].phone;
                        }
                      }
                    }

                    let tempprimarycontactphone = (<HTMLInputElement>document.getElementById('contactphoneEdit' + index)).value;

                    if (!this.primarycontactchanged) {
                      if (tempprimarycontactphone !== primarycontactphone) {
                        changedprimarycontactphone = (<HTMLInputElement>document.getElementById('contactphoneEdit' + index)).value;
                      }
                    }
                    this.contactphoneDict[this.accounts[index].primary_contact_id] = (<HTMLInputElement>document.getElementById('contactphoneEdit' + index)).value;

                    document.getElementById('owner' + index).style.display = 'block';
                    document.getElementById('ownerEdit' + index).style.display = 'none';
                    this.accounts[index].owner_id = Number(this.ownerselect);

                    document.getElementById('status' + index).style.display = 'block';
                    document.getElementById('statusEdit' + index).style.display = 'none';
                    this.accounts[index].enabled = Number(this.statusselect);


                    document.getElementById('accountrating' + index).style.display = 'block';
                    document.getElementById('accountratingEdit' + index).style.display = 'none';
                    this.accounts[index].rating = Number(this.accountRatingSelect);


                    document.getElementById('default_margin' + index).style.display = 'block';
                    document.getElementById('default_marginEdit' + index).style.display = 'none';
                    this.accounts[index].default_margin = (<HTMLInputElement>document.getElementById('default_marginEdit' + index)).value;

                    document.getElementById('customerEdit' + index).style.display = 'none';
                    document.getElementById('customerSave' + index).style.display = 'none';
                    document.getElementById('customerCancel' + index).style.display = 'none';
                    document.getElementById('ddcustButtton' + index).style.display = 'none';
                    document.getElementById('customerSpinner' + index).style.display = 'block';


                    // To implement a code to get their actual ids by collecting arrays in dictionary objects
                    this.editedContactArray = [];
                    this.editedOwnerArray = [];
                    this.editedStatusArray = [];

                    let updatecustomerdetails = {
                      id: this.accounts[index].id,
                      primaryContact_id: this.accounts[index].primary_contact_id,
                      owner_id: this.accounts[index].owner_id,
                      companyname: this.accounts[index].name,
                      addressone: this.accounts[index].address,
                      addresstwo: this.accounts[index].address2,
                      companycity: this.accounts[index].city,
                      companystate: this.accounts[index].state,
                      companyzip: this.accounts[index].zip,
                      companycountry: this.accounts[index].country,
                      margin: this.accounts[index].default_margin,
                      // companyphone: this.accounts[index].phone,
                      rating: rating,
                      companyfax: this.accounts[index].fax,
                      companyurl: this.accounts[index].website,
                      primarycontactemail: this.accounts[index].primarycontactemail,
                      primarycontactphone: this.accounts[index].primarycontactphone,
                      enabled: this.accounts[index].enabled,
                      comments: this.accounts[index].comments
                    };

                    let contactdetails;
                    if (primarycontact)
                    {
                      contactdetails = {
                        id: primarycontact.id,
                        phone: changedprimarycontactphone,
                        customer_id: this.accounts[index].id
                      };
                    }

                    // Create the project to be able to get the project ID
                    this.customerservice.updateCustomer(updatecustomerdetails)
                    .subscribe(
                      data => {
                        document.getElementById('customerSpinner' + index).style.display = 'none';
                        Materialize.toast('CUSTOMER UPDATED SUCCESSFULLY', 1500);
                        this.refreshCustomers();
                        // let projectdata = JSON.parse(data);
                      },
                      error => {
                        this.errorMessage = <any>error;
                        console.error('getProjects() error:', this.errorMessage);
                      });

                      if(primarycontact)
                      {
                        this.customerservice.updateContact(contactdetails)
                        .subscribe(
                          data => {
                            console.log('contact phone is updated : ', data);
                          },
                          error => {

                          });
                        }
                      }

                      cancelEditRow(index) {
                        document.getElementById('name' + index).style.display = 'block';
                        document.getElementById('nameEdit' + index).style.display = 'none';

                        document.getElementById('contactmail' + index).style.display = 'block';
                        document.getElementById('contactmailEdit' + index).style.display = 'none';

                        document.getElementById('contactphone' + index).style.display = 'block';
                        document.getElementById('contactphoneEdit' + index).style.display = 'none';

                        document.getElementById('owner' + index).style.display = 'block';
                        document.getElementById('ownerEdit' + index).style.display = 'none';

                        document.getElementById('status' + index).style.display = 'block';
                        document.getElementById('statusEdit' + index).style.display = 'none';

                        document.getElementById('accountrating' + index).style.display = 'block';
                        document.getElementById('accountratingEdit' + index).style.display = 'none';

                        document.getElementById('default_margin' + index).style.display = 'block';
                        document.getElementById('default_marginEdit' + index).style.display = 'none';

                        document.getElementById('customerEdit' + index).style.display = 'block';
                        document.getElementById('customerSave' + index).style.display = 'none';
                        document.getElementById('customerCancel' + index).style.display = 'none';
                        document.getElementById('ddcustButtton' + index).style.display = 'block';

                        this.editedContactArray = [];
                        this.editedOwnerArray = [];
                        this.editedStatusArray = [];
                      }

                      // logic to animate the right - down arrow on the project info table expandalbe
                      accountInfoHeaderClicked(index) {

                        console.log('accountInfoHeaderClicked');

                        if (document.getElementById(index + 'accountInfoCollapsibleBody').className == 'active') {
                          document.getElementById(index + 'accountInfoArrowRight').style.display = 'none';
                          document.getElementById(index + 'accountInfoArrowDown').style.display = 'block';
                          document.getElementById(index + 'accountInfoEdit').style.display = 'none';
                          document.getElementById(index + 'accountInfoSave').style.display = 'none';
                          document.getElementById(index + 'accountInfoCancel').style.display = 'none';


                        } else {
                          document.getElementById(index + 'accountInfoArrowRight').style.display = 'block';
                          document.getElementById(index + 'accountInfoArrowDown').style.display = 'none';
                          document.getElementById(index + 'accountInfoEdit').style.display = 'block';
                          document.getElementById(index + 'accountInfoSave').style.display = 'none';
                          document.getElementById(index + 'accountInfoCancel').style.display = 'none';
                        }

                      }

                      // edit all customer account properties in one table/expandalbe
                      editAccountInfoTable(index) {

                        // enable the status switch on edit
                        (<HTMLInputElement>document.getElementById('customerStatus' + index)).disabled = false;

                        document.getElementById('name' + index).style.display = 'none';
                        document.getElementById('nameEdit' + index).style.display = 'block';

                        document.getElementById('primaryContact' + index).style.display = 'none';
                        document.getElementById('primaryContactEdit' + index).style.display = 'block';

                        document.getElementById('primaryContactPhone' + index).style.display = 'none';
                        document.getElementById('primaryContactPhoneEdit' + index).style.display = 'block';

                        document.getElementById('customerRating' + index).style.display = 'none';
                        document.getElementById('customerRatingEdit' + index).style.display = 'block';

                        document.getElementById('defaultMargin' + index).style.display = 'none';
                        document.getElementById('defaultMarginEdit' + index).style.display = 'block';

                        document.getElementById('accountOwner' + index).style.display = 'none';
                        document.getElementById('accountOwnerEdit' + index).style.display = 'block';

                        document.getElementById('customerPhone' + index).style.display = 'none';
                        document.getElementById('customerPhoneEdit' + index).style.display = 'block';

                        document.getElementById('customerWebsite' + index).style.display = 'none';
                        document.getElementById('customerWebsiteEdit' + index).style.display = 'block';

                        document.getElementById('customerAddress' + index).style.display = 'none';
                        document.getElementById('customerAddressEdit' + index).style.display = 'block';

                        document.getElementById('customerAddress2' + index).style.display = 'none';
                        document.getElementById('customerAddress2Edit' + index).style.display = 'block';

                        document.getElementById('customerCity' + index).style.display = 'none';
                        document.getElementById('customerCityEdit' + index).style.display = 'block';

                        document.getElementById('customerState' + index).style.display = 'none';
                        document.getElementById('customerStateEdit' + index).style.display = 'block';

                        document.getElementById('customerZip' + index).style.display = 'none';
                        document.getElementById('customerZipEdit' + index).style.display = 'block';

                        document.getElementById(index + 'accountInfoEdit').style.display = 'none';
                        document.getElementById(index + 'accountInfoSave').style.display = 'inline-block';
                        document.getElementById(index + 'accountInfoCancel').style.display = 'inline-block';
                      }

                      // save edited customer aaccount properties in the table/expandalbe
                      saveAccountInfoTable(index) {
                        document.getElementById(index + 'accountInfoSave').style.display = 'none';
                        document.getElementById(index + 'accountInfoCancel').style.display = 'none';
                        document.getElementById(index + 'accountInfoSpinner').style.display = 'block';

                        document.getElementById('name' + index).style.display = 'block';
                        document.getElementById('nameEdit' + index).style.display = 'none';
                        this.selectedAccount.name = (<HTMLInputElement>document.getElementById('nameEdit' + index)).value;

                        document.getElementById('primaryContact' + index).style.display = 'block';
                        document.getElementById('primaryContactEdit' + index).style.display = 'none';
                        this.selectedAccount.primary_contact_id = (<HTMLInputElement>document.getElementById('primaryContactEdit' + index)).value;

                        document.getElementById('primaryContactPhone' + index).style.display = 'block';
                        document.getElementById('primaryContactPhoneEdit' + index).style.display = 'none';
                        this.selectedAccount.primarycontactphone = (<HTMLInputElement>document.getElementById('primaryContactPhoneEdit' + index)).value;

                        document.getElementById('customerRating' + index).style.display = 'block';
                        document.getElementById('customerRatingEdit' + index).style.display = 'none';
                        this.selectedAccount.rating = Number(this.accountRatingSelect);

                        document.getElementById('customerRating' + index).style.display = 'block';
                        document.getElementById('customerRatingEdit' + index).style.display = 'none';
                        this.selectedAccount.rating = Number(this.accountRatingSelect);

                        document.getElementById('defaultMargin' + index).style.display = 'block';
                        document.getElementById('defaultMarginEdit' + index).style.display = 'none';
                        this.selectedAccount.default_margin = (<HTMLInputElement>document.getElementById('defaultMarginEdit' + index)).value;

                        document.getElementById('accountOwner' + index).style.display = 'block';
                        document.getElementById('accountOwnerEdit' + index).style.display = 'none';
                        this.selectedAccount.owner_id = (<HTMLInputElement>document.getElementById('accountOwnerEdit' + index)).value;

                        document.getElementById('customerPhone' + index).style.display = 'block';
                        document.getElementById('customerPhoneEdit' + index).style.display = 'none';
                        this.selectedAccount.phone = (<HTMLInputElement>document.getElementById('customerPhoneEdit' + index)).value;

                        document.getElementById('customerWebsite' + index).style.display = 'block';
                        document.getElementById('customerWebsiteEdit' + index).style.display = 'none';
                        this.selectedAccount.website = (<HTMLInputElement>document.getElementById('customerWebsiteEdit' + index)).value;

                        document.getElementById('customerAddress' + index).style.display = 'block';
                        document.getElementById('customerAddressEdit' + index).style.display = 'none';
                        this.selectedAccount.address = (<HTMLInputElement>document.getElementById('customerAddressEdit' + index)).value;

                        document.getElementById('customerAddress2' + index).style.display = 'block';
                        document.getElementById('customerAddress2Edit' + index).style.display = 'none';
                        this.selectedAccount.address2 = (<HTMLInputElement>document.getElementById('customerAddress2Edit' + index)).value;

                        document.getElementById('customerCity' + index).style.display = 'block';
                        document.getElementById('customerCityEdit' + index).style.display = 'none';
                        this.selectedAccount.city = (<HTMLInputElement>document.getElementById('customerCityEdit' + index)).value;

                        document.getElementById('customerState' + index).style.display = 'block';
                        document.getElementById('customerStateEdit' + index).style.display = 'none';
                        this.selectedAccount.state = (<HTMLInputElement>document.getElementById('customerStateEdit' + index)).value;

                        document.getElementById('customerZip' + index).style.display = 'block';
                        document.getElementById('customerZipEdit' + index).style.display = 'none';
                        this.selectedAccount.zip = (<HTMLInputElement>document.getElementById('customerZipEdit' + index)).value;

                        this.selectedAccount.primary_contact_id = this.primarycontactselect;
                        this.selectedAccount.owner_id = this.ownerselect;

                        let updatecustomerdetails = {
                          id: this.selectedAccount.id,
                          primaryContact_id: this.selectedAccount.primary_contact_id,
                          owner_id: this.selectedAccount.owner_id,
                          companyname: this.selectedAccount.name,
                          addressone: this.selectedAccount.address,
                          addresstwo: this.selectedAccount.address2,
                          companycity: this.selectedAccount.city,
                          companystate: this.selectedAccount.state,
                          companyzip: this.selectedAccount.zip,
                          companycountry: this.selectedAccount.country,
                          companyphone: this.selectedAccount.phone,
                          companyfax: this.selectedAccount.fax,
                          companyurl: this.selectedAccount.website,
                          margin: this.selectedAccount.default_margin,
                          rating: this.selectedAccount.rating,
                          enabled: this.selectedAccount.enabled,
                        };

                        let contactdetails = {
                          id: this.selectedAccount.primary_contact_id,
                          phone: this.selectedPrimaryContact.phone,
                          customer_id: this.selectedAccount.id
                        };

                        // Upadate the customer account and refresh the table
                        this.customerservice.updateCustomer(updatecustomerdetails)
                        .subscribe(
                          data => {
                            console.log('Project added to DB');
                            console.log('addProject data:', data);
                            Materialize.toast('CUSTOMER UPDATED SUCCESSFULLY', 1500);
                            this.refreshCustomers();
                            this.refreshCustomersInfo(updatecustomerdetails.id);
                            // set back the icon displays
                            document.getElementById(index + 'accountInfoEdit').style.display = 'block';
                            document.getElementById(index + 'accountInfoSave').style.display = 'none';
                            document.getElementById(index + 'accountInfoCancel').style.display = 'none';
                            document.getElementById(index + 'accountInfoSpinner').style.display = 'none';
                            // disable the status switch
                            (<HTMLInputElement>document.getElementById('customerStatus' + index)).disabled = true;
                          },
                          error => {
                            this.errorMessage = <any>error;
                            console.error('getProjects() error:', this.errorMessage);
                          });
                          this.customerservice.updateContact(contactdetails)
                          .subscribe(
                            data => {
                              console.log('contact phone is updated : ', data);
                            },
                            error => {

                            });
                          }


                          // cancel all customer account properties edits in one table/expandalbe
                          cancelAccountInfoTable(index) {
                            document.getElementById('name' + index).style.display = 'block';
                            document.getElementById('nameEdit' + index).style.display = 'none';

                            document.getElementById('primaryContact' + index).style.display = 'block';
                            document.getElementById('primaryContactEdit' + index).style.display = 'none';

                            document.getElementById('primaryContactPhone' + index).style.display = 'block';
                            document.getElementById('primaryContactPhoneEdit' + index).style.display = 'none';

                            document.getElementById('customerRating' + index).style.display = 'block';
                            document.getElementById('customerRatingEdit' + index).style.display = 'none';

                            document.getElementById('defaultMargin' + index).style.display = 'block';
                            document.getElementById('defaultMarginEdit' + index).style.display = 'none';

                            document.getElementById('accountOwner' + index).style.display = 'block';
                            document.getElementById('accountOwnerEdit' + index).style.display = 'none';

                            document.getElementById('customerPhone' + index).style.display = 'block';
                            document.getElementById('accountOwnerEdit' + index).style.display = 'none';

                            document.getElementById('customerWebsite' + index).style.display = 'block';
                            document.getElementById('customerWebsiteEdit' + index).style.display = 'none';

                            document.getElementById('customerAddress' + index).style.display = 'block';
                            document.getElementById('customerAddressEdit' + index).style.display = 'none';

                            document.getElementById('customerAddress2' + index).style.display = 'block';
                            document.getElementById('customerAddress2Edit' + index).style.display = 'none';

                            document.getElementById('customerCity' + index).style.display = 'block';
                            document.getElementById('customerCityEdit' + index).style.display = 'none';

                            document.getElementById('customerState' + index).style.display = 'block';
                            document.getElementById('customerStateEdit' + index).style.display = 'none';

                            document.getElementById('customerZip' + index).style.display = 'block';
                            document.getElementById('customerZipEdit' + index).style.display = 'none';

                            document.getElementById(index + 'accountInfoEdit').style.display = 'block';
                            document.getElementById(index + 'accountInfoSave').style.display = 'none';
                            document.getElementById(index + 'accountInfoCancel').style.display = 'none';
                            // disable the status switch
                            (<HTMLInputElement>document.getElementById('customerStatus' + index)).disabled = true;
                          }


                          editContactRow(index) {
                            document.getElementById('contName' + index).style.display = 'none';
                            document.getElementById('contFirstnameEdit' + index).style.display = 'inline-block';
                            document.getElementById('contLastnameEdit' + index).style.display = 'inline-block';

                            document.getElementById('contEmail' + index).style.display = 'none';
                            document.getElementById('contEmailEdit' + index).style.display = 'block';

                            document.getElementById('contPhone' + index).style.display = 'none';
                            document.getElementById('contPhoneEdit' + index).style.display = 'block';

                            document.getElementById('contTitle' + index).style.display = 'none';
                            document.getElementById('contTitleEdit' + index).style.display = 'block';


                            document.getElementById('contpencil' + index).style.display = 'none';
                            document.getElementById('contapply' + index).style.display = 'block';
                            document.getElementById('contcancel' + index).style.display = 'block';
                            document.getElementById('contactRemoveIcon' + index).style.display = 'none';

                          }

                          saveContactRow(index) {

                            document.getElementById('contapply' + index).style.display = 'none';
                            document.getElementById('contcancel' + index).style.display = 'none';

                            document.getElementById('contName' + index).style.display = 'block';
                            document.getElementById('contFirstnameEdit' + index).style.display = 'none';
                            document.getElementById('contLastnameEdit' + index).style.display = 'none';
                            this.contacts[index].firstname = (<HTMLInputElement>document.getElementById('contFirstnameEdit' + index)).value;
                            this.contacts[index].lastname = (<HTMLInputElement>document.getElementById('contLastnameEdit' + index)).value;

                            document.getElementById('contEmail' + index).style.display = 'block';
                            document.getElementById('contEmailEdit' + index).style.display = 'none';
                            this.contacts[index].email = (<HTMLInputElement>document.getElementById('contEmailEdit' + index)).value;

                            document.getElementById('contPhone' + index).style.display = 'block';
                            document.getElementById('contPhoneEdit' + index).style.display = 'none';
                            this.contacts[index].phone = (<HTMLInputElement>document.getElementById('contPhoneEdit' + index)).value;

                            document.getElementById('contTitle' + index).style.display = 'block';
                            document.getElementById('contTitleEdit' + index).style.display = 'none';
                            this.contacts[index].title = (<HTMLInputElement>document.getElementById('contTitleEdit' + index)).value;

                            let contactdetails = {
                              id: this.contacts[index].id,
                              firstname: this.contacts[index].firstname,
                              lastname: this.contacts[index].lastname,
                              email: this.contacts[index].email,
                              phone: this.contacts[index].phone,
                              title: this.contacts[index].title,
                              customer_id: this.selectedAccount.id
                            };

                            // Create the project to be able to get the project ID
                            this.customerservice.updateContact(contactdetails)
                            .subscribe(
                              data => {
                                console.log('Contact updated of customer : ' + this.selectedAccount.name);
                                console.log('update contact data:', data);
                                Materialize.toast('CONTACT UPDATED SUCCESSFULLY', 2000);
                                this.refreshCustomersInfo(this.selectedAccount.id);
                                this.refreshCustomers();
                                document.getElementById('contpencil' + index).style.display = 'block';
                                document.getElementById('contactRemoveIcon' + index).style.display = 'block';
                              },
                              error => {
                                this.errorMessage = <any>error;
                                console.error('getProjects() error:', this.errorMessage);
                              });
                            }

                            cancelEditContactRow(index) {
                              document.getElementById('contName' + index).style.display = 'block';
                              document.getElementById('contFirstnameEdit' + index).style.display = 'none';
                              document.getElementById('contLastnameEdit' + index).style.display = 'none';

                              document.getElementById('contEmail' + index).style.display = 'block';
                              document.getElementById('contEmailEdit' + index).style.display = 'none';

                              document.getElementById('contPhone' + index).style.display = 'block';
                              document.getElementById('contPhoneEdit' + index).style.display = 'none';

                              document.getElementById('contTitle' + index).style.display = 'block';
                              document.getElementById('contTitleEdit' + index).style.display = 'none';

                              document.getElementById('contpencil' + index).style.display = 'block';
                              document.getElementById('contapply' + index).style.display = 'none';
                              document.getElementById('contcancel' + index).style.display = 'none';
                              document.getElementById('contactRemoveIcon' + index).style.display = 'block';
                            }

                            checkContactEmptyField() {
                              if (this.newContactfirstname && this.newContactlastname) {
                                this.requiredContactfieldEmpty = false;
                              } else {
                                this.requiredContactfieldEmpty = true;
                              }
                            }

                            addIndicatorStyle() {
                              $('#modalCustomerInfo').find('.indicator').attr('style', 'right: 66%; left: 0px;');
                            }

                            onShowProjects() {
                              this.dropdownActive = false;
                              this.service.setProjectSearchResultBool(true);
                              this.service.setSearchResultData('projects', {customer : this.selectedAccount.id});
                              this.router.navigate(['/projects']);
                            }

                            onShowQuotes() {

                            }

                            createNewCustomerContact() {
                              console.log(' Contact name : ' + this.newContactfirstname + ' ' + this.newContactlastname);
                              if (this.requiredContactfieldEmpty) {
                                Materialize.toast('FIRST AND LAST NAME ARE REQUIRED!', 4000);
                                return;
                              }

                              this.waiticon = 'fa right fa-spinner fa-pulse';
                              (<HTMLInputElement>document.getElementById('CreateNewCustomerContact')).disabled = true;

                              this.ownerselect = Number(this.getKeyByValue(this.ownerEmailDict, this.selectedassignee));

                              let accountdetails = {
                                firstname: this.newContactfirstname,
                                lastname: this.newContactlastname,
                                email: this.newContactemail,
                                phone: this.newContactphone,
                                title: this.newContacttitle,
                                customer_id: this.selectedAccount.id
                              };

                              this.customerservice.addContact(accountdetails)
                              .subscribe(
                                data => {
                                  console.log('customer data : ', data);
                                  this.waiticon = '';
                                  (<HTMLInputElement>document.getElementById('CreateNewCustomerContact')).disabled = false;
                                  Materialize.toast(this.newContactfirstname + ' ' + this.newContactlastname + ' ADDED AS A CONTACT SUCCESSFULLY', 3000);
                                  this.modalNewAccountContactAction.emit({ action: 'modal', params: ['close'] });
                                  this.refreshCustomersInfo(this.selectedAccount.id);
                                  this.refreshCustomers();
                                },
                                error => {
                                  this.waiticon = '';
                                  (<HTMLInputElement>document.getElementById('CreateNewCustomerContact')).disabled = false;
                                  console.log('CONTACT CREATION FAILED : ', error);
                                  Materialize.toast('CONTACT CREATION FAILED!', 2000);
                                });
                              }

                              editCommentRow() {
                                
                                (<HTMLInputElement>document.getElementById('customerCommentTextArea')).value = this.selectedAccount.comments;

                                document.getElementById('comments').style.display = 'none';
                                document.getElementById('commentsEdit').style.display = 'block';
                                document.getElementById('commentpencil').style.display = 'none';
                                document.getElementById('commentapply').style.display = 'block';
                                document.getElementById('commentcancel').style.display = 'block';

                              }

                              saveCommentRow() {
                                let comment = (<HTMLInputElement>document.getElementById('customerCommentTextArea')).value;

                                this.selectedAccount.comments = comment;

                                document.getElementById('comments').style.display = 'block';
                                document.getElementById('commentsEdit').style.display = 'none';
                                document.getElementById('commentpencil').style.display = 'block';
                                document.getElementById('commentapply').style.display = 'none';
                                document.getElementById('commentcancel').style.display = 'none';

                                this.customerservice.updateComment(this.selectedAccount.id, comment).subscribe(
                                  data => {
                                    console.log('comments updated ', data);
                                    this.selectedAccount.comments = comment;
                                  },
                                  error => {

                                  }
                                );
                              }

                              cancelEditCommentRow() {
                                document.getElementById('comments').style.display = 'block';
                                document.getElementById('commentsEdit').style.display = 'none';

                                document.getElementById('commentpencil').style.display = 'block';
                                document.getElementById('commentapply').style.display = 'none';
                                document.getElementById('commentcancel').style.display = 'none';
                              }

                              onPageChange(number: number) {
                                console.log('change to page', number);
                                this.config.currentPage = number;
                                this.loadingcustomers = true;
                                this.accounts = [];
                                this.refreshCustomers();
                              }


                              calculateStarRating(accountindex, rating) {
                                this.filledstar = Math.floor(rating / 1);
                                this.halfstar = rating % 1;
                                if (this.halfstar) {
                                  this.halfstar = 1;
                                }
                                this.emptystar = Math.floor(5 - rating);

                                this.accounts[accountindex].filledstar = this.filledstar;
                                this.accounts[accountindex].halfstar = this.halfstar;
                                this.accounts[accountindex].emptystar = this.emptystar;
                              }

                              calculateStarRatingForSelectedAccount(rating) {
                                this.filledstar = Math.floor(rating / 1);
                                this.halfstar = rating % 1;
                                if (this.halfstar) {
                                  this.halfstar = 1;
                                }
                                this.emptystar = Math.floor(5 - rating);

                                this.selectedAccount.filledstar = this.filledstar;
                                this.selectedAccount.halfstar = this.halfstar;
                                this.selectedAccount.emptystar = this.emptystar;
                              }

                              createRange(number) {
                                let items: number[] = [];
                                for (let i = 1; i <= number; i++) {
                                  items.push(i);
                                }
                                return items;
                              }

                              onCreateCustomerComplete () {
                                this.refreshCustomers();
                              }

                            }



// WEBPACK FOOTER //
// /Users/mark/Documents/Source/MachineResearch/MR2/angular2/src/app/customers/customers.component.ts